import React from 'react';
import PropTypes from 'prop-types';
import JourneyStepProp from '../../../journey/propTypes/journeyStepProp';
import { TROPHY_CONFIG } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import JourneyBannerCoins from './JourneyBannerCoins';

export const REWARD_TYPE = {
  TROPHY: 'trophy',
  COINS: 'coins',
  COUPON: 'coupon',
  VOUCHER: 'voucher',
};

const rewardImage = (type, step) => {
  const rewards = step.rewards || {};
  const placeholder = '/images/no_image_upload.png';

  switch (type) {
    case REWARD_TYPE.TROPHY: {
      const trophiesToDisplay = Object.entries(rewards.trophies)
        .filter(([trophy, value]) => !!value)
        .map(([trophy]) => trophy);
      const trophyReward =
        trophiesToDisplay.length > 0 ? trophiesToDisplay[0] : null;
      const trophy = step.trophy || trophyReward;

      if (trophy && trophy !== 'custom') {
        return TROPHY_CONFIG[trophy].imageURL;
      }
      return step.trophyCustom && step.trophyCustom.icon
        ? step.trophyCustom.icon.thumb
        : TROPHY_CONFIG.custom.imageURL;
    }
    case REWARD_TYPE.COUPON:
      return rewards.coupons[0].image
        ? rewards.coupons[0].image.thumb
        : placeholder;
    case REWARD_TYPE.VOUCHER:
      return rewards.vouchers[0].logo
        ? rewards.vouchers[0].logo.thumb
        : placeholder;
    default:
      return placeholder;
  }
};

const rewardText = (t, type, step) => {
  const placeholder = t('n/a');
  const rewards = step.rewards || {};

  switch (type) {
    case REWARD_TYPE.TROPHY: {
      const trophiesToDisplay = Object.entries(rewards.trophies)
        .filter(([trophy, value]) => !!value)
        .map(([trophy]) => trophy);
      const trophyReward =
        trophiesToDisplay.length > 0 ? trophiesToDisplay[0] : null;
      const trophy = step.trophy || trophyReward;

      if (trophy && trophy !== 'custom') {
        return t(TROPHY_CONFIG[trophy].translationKey);
      }
      return step.trophyCustom && step.trophyCustom.name
        ? `${t('journey_stepType_trophy')}: ${step.trophyCustom.name}`
        : t(TROPHY_CONFIG.custom.translationKey);
    }
    case REWARD_TYPE.COUPON:
      return rewards.coupons[0].name
        ? `${t('journey_coupon')}: ${rewards.coupons[0].name}`
        : t('journey_coupon');
    case REWARD_TYPE.VOUCHER:
      return rewards.vouchers[0].name
        ? `${t('journey_voucher')}: ${rewards.vouchers[0].name}`
        : t('journey_voucher');
    default:
      return placeholder;
  }
};

function JourneyBannerNextReward({ t, type, step }) {
  const rewards = step.rewards || {};
  const coins = rewards.coins || {};

  return (
    <div className="journey-next-step">
      <h6>{t('journey_nextReward')}</h6>
      {type !== REWARD_TYPE.COINS ? (
        <div className="journey-next-step-info">
          <img
            src={rewardImage(type, step)}
            alt="step preview"
            className="reward-image"
          />
          <div className="journey-next-step-title-progress">
            <h5>{rewardText(t, type, step)}</h5>
          </div>
        </div>
      ) : (
        <JourneyBannerCoins coins={coins} />
      )}
    </div>
  );
}

JourneyBannerNextReward.propTypes = {
  t: PropTypes.func.isRequired,
  type: PropTypes.oneOf(Object.values(REWARD_TYPE)).isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
};

export default translate(JourneyBannerNextReward);
